import * as ActionTypes from './ActionTypes';

// todo: I couldn't get this to work
export const ComboResults = (state, action) => {
    if(state === undefined)
    {
      return {numberRight: 0, numberWrong: 0, moveIndex: 0}
    }

    var numberRight = state.numberRight;
    var numberWrong = state.numberWrong;
    var moveIndex = state.moveIndex;

    switch (action.type) {
      case ActionTypes.UPDATE_NUMBER_RIGHT:
          return {numberRight: numberRight + 1, moveIndex: moveIndex + 1};
      case ActionTypes.UPDATE_NUMBER_WRONG:
          return {numberWrong: numberWrong + 1, moveIndex: moveIndex};
      case ActionTypes.RESET_MOVE_INDEX:
        return {moveIndex: 0};
      default:
         return state;
      }
};
